<template>
  <!-- BEGIN pos-menu -->
  <div class="pos-menu">
    <a href="#" @click.prevent="$emit('back-home')">
      <div class="logo">
        <div class="logo-img">
          <img v-lazy="{
            src: companyLogo,
            error: require('@/assets/logo.png')
          }" />
        </div>
        <!-- <div class="logo-text">Pine & Dine</div> -->
      </div>
    </a>
    <div class="nav-container overflow-auto">
      <div data-scrollbar="true" data-height="100%" data-skip-mobile="true">
        <ts-tabs-horizontal target="gTab">
          <ts-tab-horizontal @click="$emit('change-category')">
            <i class="fas fa-star fa-2x fa-fw"></i>
            Top 20 Sale
          </ts-tab-horizontal>
          <ts-tab-horizontal v-for="(c, index) in productCategory" :key="index"
            @click="$emit('change-category', c.category_id)">
            <i :class="c.icon" class="fa-2x fa-fw"></i>
            {{ locale == 'kh' ? c.category_name_kh : c.category_name_en }}
          </ts-tab-horizontal>
        </ts-tabs-horizontal>
      </div>
    </div>
    <div class="ts-p-1 ts-w-full pos-sidebar-footer ts-whitespace-no-wrap bussiness-unit">
      <a-button class="ts-w-full icon-btn" @click="onShowFrom">
        <i class="fab fa-blogger-b"></i>
      </a-button>
      <a-button class="ts-w-full text-btn" @click="onShowFrom">
        {{ $t('restaurantSale.businessUnit') }}
      </a-button>
    </div>
    <div class="pos-sidebar-footer ts-whitespace-no-wrap pos-sidebar-footer-left">
      <h4 class="time text-center">{{ currentTime }}</h4>
      <div><i class="far fa-calendar-alt"></i> {{ currentDate }}</div>
      <div>
        <i class="fas fa-user"></i>
        {{ $store.state.authUser.user.name }}
      </div>
      <div>
        FX
        {{ exchangeRate + ' ' + toCurrency }}
      </div>
    </div>
    <a-modal v-if="show_from" v-model="show_from" :title="$t('restaurantSale.businessUnit')" :footer="null"
      :centered="true" :maskClosable="false" :zIndex="1000" width="350px">
      <div class="ts-space-y-4">
        <div class="row">
          <div class="col-md-12">
            <a-select v-model="business_unit_id" mode="multiple" :maxTagCount="1" style="width: 100%" placeholder="All"
              class="ts-w-full" :options="businessUnitLists" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
            <ts-button :disabled="loading" @click.prevent="() => show_from = false">{{ $t('cancel') }}
            </ts-button>
            <ts-button :disabled="loading" @click.prevent="onSave" color="primary">{{ $t('save') }}</ts-button>
          </div>
        </div>
      </div>
      <Spin size="large" fix v-if="loading"></Spin>
    </a-modal>
  </div>
  <!-- END pos-menu -->
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'PosMenu',
  props: {
    currentTime: String,
    currentDate: String,
    exchangeRate: Number,
    toCurrency: String,
    companyLogo: String,
    productCategory: Array,
    locale: String
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      show_from: false,
      businessUnits: [],
      business_unit_id: [],
    }
  },
  created() {
    this.getPreData()
  },
  computed: {
    businessUnitLists() {
      if (this.businessUnits) {
        return this.businessUnits.map(el => ({
          value: el.id,
          label: el.display_name,
        }))
      }
      return []
    },
  },
  methods: {
    onShowFrom() {
      this.show_from = true
      this.$nextTick(() => {
        document.querySelectorAll('.ant-select-search__field').forEach(el => {
          el.setAttribute('readonly', true);
        });
      });
    },
    getPreData() {
      this.loading = true
      this.errors = new Errors()
      this.$store.dispatch('restaurantSale/customerOrder/fetchBusinessUnit')
        .then(response => {
          this.businessUnits = response.data.business_unit
          this.business_unit_id = response.data.current_business_unit_id
          this.$store.state.authUser.user.current_business_unit_id = response.data.current_business_unit_id
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.loading = true
      this.errors = new Errors()
      this.$store.dispatch('restaurantSale/customerOrder/assignBusinessUnit', {
        business_unit_id: this.business_unit_id,
      })
        .then(response => {
          this.$store.state.authUser.user.current_business_unit_id = this.business_unit_id
          this.$toasted.success(response.message)
          this.$emit('changeBusinessUnits')
          this.show_from = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>

<style scoped>
.pos-customer .pos-menu .logo {
  padding: 12px;
}

.pos-customer .pos-menu .logo .logo-img {
  text-align: center;
  height: 105px;
}

.nav-container {
  top: 2;
  background: #f2f3f4;
  color: #5b6166;
}

.pos-sidebar-footer {
  background: #495057 !important;
  color: #f8f9fa;
  position: relative;
  padding: 10px 25px;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  -webkit-box-shadow: 0 -1px rgba(52, 58, 64, 0.1);
  box-shadow: 0 -1px rgba(52, 58, 64, 0.1);
}

.time {
  font-family: 'Times New Roman', serif;
  font-weight: bold;
  font-size: 28px;
  text-transform: uppercase;
  line-height: 1;
  text-align: center;
  background: linear-gradient(90deg,
      rgba(186, 148, 62, 1) 0%,
      rgba(236, 172, 32, 1) 20%,
      rgba(186, 148, 62, 1) 39%,
      rgb(250, 242, 125) 50%,
      rgba(186, 148, 62, 1) 60%,
      rgba(236, 172, 32, 1) 80%,
      rgba(186, 148, 62, 1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 3s infinite;
  background-size: 200%;
  background-position: left;
}

@keyframes shine {
  to {
    background-position: right;
  }
}

.bussiness-unit {
  padding: 4px;
}

.bussiness-unit .icon-btn {
  display: none;
}

@media (max-width: 991.98px) {

  .pos-customer .pos-menu .logo,
  .pos-sidebar-footer-left {
    display: none;
  }

  .bussiness-unit {
    background-color: transparent !important;
    width: 50px;
    margin: 0px 4px 0px 0px;
    font-size: 13px;
  }

  .bussiness-unit .ant-btn {
    height: 64px;
    padding: 0 12px;
    font-size: 21px;
  }

  .bussiness-unit .icon-btn {
    display: block;
  }

  .bussiness-unit .text-btn {
    display: none;
  }

  .pos-customer .pos-menu .nav-container {
    padding: 2px 0;
  }

  .pos-customer .pos-menu .nav.nav-tabs {
    margin-top: 2px;
  }
}
</style>